export default {
  aboutapp: {
    subtitle: "معلومات عنا",
    title: "مرحبًا بكم في متجر المنتجات العضوية",

    desc:
      "هناك العديد من أشكال نصوص لوريم إيبسوم، ولكن الغالبية تعرضت لتعديلات بطريقة ما.",

    li1: "منتجات عضوية عالية الجودة",
    li2: "طعام صحي يوميًا",
    li3: "منتجات طازجة من المزارع المحلية",
    li4: "تجربة شراء مميزة",

    cta: "ابدأ استخدام ماهال اليوم",

    quote:
      "هناك العديد من أشكال النصوص المتاحة، لكن الغالبية تعرضت للتغيير.",
    author: "روبرت داي",
  },
};